<template>
	<!-- <iframe :src="html"></iframe> -->
	<div>
		<img src="../../assets/aaaa.jpg" style="width: 100%; heightL auto" />
		<br><br><br><br><br><br><br><br><br><br><br><br><hr><br><br><br><br><br><br><br><br><br><br><br><br>
		<img src="../../assets/bbbb.jpg" style="width: 100%; heightL auto" />
		<br><br><br><br><br><br><br><br><br><br><br><br><hr><br><br><br><br><br><br><br><br><br><br><br><br>
		<img src="../../assets/cccc.jpg" style="width: 100%; heightL auto" />

	</div>
</template>

<script>
	export default {
		data() {
			return {
				html: "https://jinshuju.net/f/zMw9Ew",
			}
		},
		created() {
			// this.html = this.$route.query.html;
			// console.log(this.html)
		} 
	}
</script>

<style>
	html,
	body,
	iframe,
	#app {
		width: 100%;
		height: 100%;
	}
</style>
